import useApi from "../../index";

const useConfigurationActions = () => {
  // Services
  const { useServices } = useApi();
  const { useConfigurationServices } = useServices();
  const { getConfigurationService, saveConfigurationService } = useConfigurationServices();

  const actGetConfiguration = (key, onSuccess, onError) => async () => {
    try {
      const response = await getConfigurationService(key);
      onSuccess && onSuccess(response.data);
    } catch (error) {
      onError && onError(error);
    }
  };

  const actSaveConfiguration = ({ data }, onSuccess, onError) => async () => {
    try {
      const response = await saveConfigurationService(data);
      onSuccess && onSuccess(response.data);
    } catch (error) {
      onError && onError(error);
    }
  };

  return {
    actGetConfiguration,
    actSaveConfiguration,
  };
};

export default useConfigurationActions;
